import { useEffect, useRef } from 'react';
import type { UpsellSurface } from 'fym-shared/src/music24/watermarkUpsell';
import { useUpsellEventFacts } from './useUpsellEventFacts';
import { trackUpsellShown } from './watermarkUpsellAnalytics';

/**
 * Sends `upsell_shown` one time while `isShown` is true and the component is mounted: one event for
 * each page view of an always-on surface, one for each opening of a modal.
 */
export function useUpsellShown(surface: UpsellSurface, isShown: boolean): void {
  const eventFacts = useUpsellEventFacts();
  const sent = useRef(false);
  useEffect(() => {
    if (!isShown) {
      sent.current = false;
      return;
    }
    if (sent.current) {
      return;
    }
    sent.current = true;
    trackUpsellShown(eventFacts(surface));
  }, [eventFacts, isShown, surface]);
}
